import React from 'react';
import './style.css'

const Header = () => {
  return (
    <div className='header'>
        <h2>Tic Tac Toe</h2>
    </div>
  )
}

export default Header